/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MediaInfo { 
    mediaId: string;
    mediaFileName: string;
    mediaMimeType: string;
    mediaName: string;
    mediaDescription?: string | null;
    mediaCrc?: string | null;
    mediaSettings?: string | null;
}

